import { render } from "./InfoBeveiliging.vue?vue&type=template&id=11a37d72&scoped=true"
import script from "./InfoBeveiliging.vue?vue&type=script&lang=js"
export * from "./InfoBeveiliging.vue?vue&type=script&lang=js"

import "./InfoBeveiliging.vue?vue&type=style&index=0&id=11a37d72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a37d72"]])

export default __exports__